import Component from '@glimmer/component'
import { service } from '@ember/service'
import { t } from 'ember-intl'
import type { BufferedChangeset } from 'ember-changeset/types'
import type ProgressHandlerService from 'teacher-ui-client/services/progress-handler'
import type { ProgressionRecord } from 'teacher-ui-client/progress-handler/utils'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { EditProgressSelect } from 'teacher-ui-client/components/form/edit-progress/select'
import featureFlag from 'teacher-ui-client/helpers/feature-flag'

interface Args {
  progressChangeset: BufferedChangeset
  /**
   * An array of progression items from student-progress service for a student
   */
  studentProgression?: ProgressionRecord[]
}

interface Signature {
  Element: HTMLDivElement
  Args: Args
  Blocks: {
    default: []
  }
}

export class EditProgressMathseedsPrime extends Component<Signature> {
  themeKey = ThemeKeys.darkBlue

  @service progressHandler!: ProgressHandlerService

  <template>
    <div class="grid grid-cols-[33%_66%] items-baseline justify-between gap-y-3" ...attributes>
      <label for={{this.progressHandler.mathseedsPrimeNumberHandler.progressType}}>
        {{t "mathseedsPrimeThreads.number.name"}}
      </label>
      <EditProgressSelect
        @progressHandler={{this.progressHandler.mathseedsPrimeNumberHandler}}
        @progressChangeset={{@progressChangeset}}
        @studentProgression={{@studentProgression}}
        @themeKey={{this.themeKey}}
      />
      <label for={{this.progressHandler.mathseedsPrimeFractionsHandler.progressType}}>
        {{t "mathseedsPrimeThreads.fractions.name"}}
      </label>
      <EditProgressSelect
        @progressHandler={{this.progressHandler.mathseedsPrimeFractionsHandler}}
        @progressChangeset={{@progressChangeset}}
        @studentProgression={{@studentProgression}}
        @themeKey={{this.themeKey}}
      />
      <label for={{this.progressHandler.mathseedsPrimeOperationsHandler.progressType}}>
        {{t "mathseedsPrimeThreads.operations.name"}}
      </label>
      <EditProgressSelect
        @progressHandler={{this.progressHandler.mathseedsPrimeOperationsHandler}}
        @progressChangeset={{@progressChangeset}}
        @studentProgression={{@studentProgression}}
        @themeKey={{this.themeKey}}
      />
      <label for={{this.progressHandler.mathseedsPrimeGeometryHandler.progressType}}>
        {{t "mathseedsPrimeThreads.geometry.name"}}
      </label>
      <EditProgressSelect
        @progressHandler={{this.progressHandler.mathseedsPrimeGeometryHandler}}
        @progressChangeset={{@progressChangeset}}
        @studentProgression={{@studentProgression}}
        @themeKey={{this.themeKey}}
      />
      {{#if (featureFlag "tui_ms_prime_progress_measurement")}}
        <label for={{this.progressHandler.mathseedsPrimeMeasurementHandler.progressType}}>
          {{t "mathseedsPrimeThreads.measurement.name"}}
        </label>
        <EditProgressSelect
          @progressHandler={{this.progressHandler.mathseedsPrimeMeasurementHandler}}
          @progressChangeset={{@progressChangeset}}
          @studentProgression={{@studentProgression}}
          @themeKey={{this.themeKey}}
        />
      {{/if}}
    </div>
  </template>
}

export default EditProgressMathseedsPrime
